var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',{attrs:{"labelText":"Vehicle Type","options":_vm.options},on:{"change":_vm.onChange,"input":_vm.onChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }